module.exports = __webpack_public_path__ + "static/media/wrirk-crm.87fe1588.png";